/************
 * Model Class
 * File Name ...: regions.components.ts
 * Generated By : ianday on 11/1/23
 * Date ........: 11/1/23
 /************/
import {ValidationResult} from './validation-result';

export interface Region {
    id: number | null;
    description: string | null;
    zipCode: string | null;
    county: string | null;
}

export class Region {
    constructor() {
        this.id = 0;
        this.description = '';
        this.zipCode = '';
        this.county = '';
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if (this.description.length === 0) {
            vr.focus_field = 'description';
            vr.error = 'Error: a region is required';
            return vr;
        }
        if (this.zipCode.toString().length !== 5) {
            vr.focus_field = 'zipCode';
            vr.error = 'Error: a five digit Zip Code is required';
            return vr;
        }
        if (this.county.length === 0) {
            vr.focus_field = 'county';
            vr.error = 'Error: a county is required';
            return vr;
        }
        return vr;
    }
}
